'use strict';

angular.module('myConsultApp')
    .directive( 'dashboardTile', function (CmsService, $rootScope, $resource,ENV,Session,$window, $compile) {
		  return {
		    restrict: 'E',
	      transclude: true,
	      scope: {
	        appType: '@',
	        id: '='
	      },
	      link: function(scope, el, attr) {
			    
			      CmsService.getDashboardTile().then(function(response) {
				      scope.cmsLoaded = false;
					    scope.dashboardTileTitle = response.title;
				      scope.dashboardTileSubtitle = response.subtitle;
				      var insertDiv = '<div class="full-width full-height panel-bkg align-center"><h2>' + scope.dashboardTileTitle + '</h2><h3>' + scope.dashboardTileSubtitle + '</h3><div class="content" id="dashboard-announcement">' + response.body + '</div></div>';
				      scope.cmsLoaded = true;
				      var $body = $(insertDiv);
				      $body.find('a').each(function(){
					      if($(this).attr('href').indexOf(ENV.proURL) >= 0){
						      $(this).attr('target','');
						      var thisHref = $(this).attr('href').replace(ENV.proURL,'.');
						      $(this).attr('ng-href',thisHref);
						      $(this).attr('href','#');
					      }else if($(this).attr('href').indexOf('slug:') >= 0){
						    	$(this).attr('target','');
						      var thisHref = $(this).attr('href').replace('slug:','');
						      $(this).attr('ng-href','./' + thisHref);
						      $(this).attr('href','#');
						    } else {
							    $(this).attr('target','_blank');
						    }
				      });
				      var dashboardTile = $compile( $body )( scope );
				      el.append(dashboardTile);
				      
				    });
		    }
		  };
		});
